import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RefreshComponent } from './refresh/refresh.component';
import { AppInterceptorService } from './app-interceptor.service';
import { Router } from '@angular/router';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { TraceService, createErrorHandler } from '@sentry/angular-ivy';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
import { MessagingService } from './shared/firebase/messaging.service';
import { DatePipe } from '@angular/common';
import { CommonImportsModule } from './shared/common-imports/common-imports.module';

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		RefreshComponent,
		ResetPasswordNewComponent
	],
	imports: [
		AppRoutingModule,
		CommonImportsModule,
		BrowserAnimationsModule,
		BrowserModule
	],
	providers: [
		{
			provide: ErrorHandler,
			useValue: createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => { },
			deps: [TraceService],
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AppInterceptorService,
			multi: true
		},
		MatNativeDatetimeModule,
		DatePipe,
		MessagingService
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
